import { SSVIntlApi } from './baseHttp';

// 获取用户信息
export function getUserInfo() {
  return SSVIntlApi.get<any>(
    '/portalWebAPI/techforgood/activity/signuprecords/detail',
    {
      isOnlyValidateReq: true,
      errorMessage: false,
    }
  );
}
// 退出登录
export function logOut() {
  return SSVIntlApi.get<any>('/api/user/SSVOPEN/logout', {
    skipIntercept: true,
    errorMessage: false,
  });
}

// 用户信息补充
export function addSupplementInfo(params = {}) {
  return SSVIntlApi.post(
    '/portalWebAPI/techforgood/activity/signuprecords/save',
    params,
    {}
  );
}

// 用户信息跳过
export function skipSupplementInfo() {
  return SSVIntlApi.post(
    '/portalWebAPI/techforgood/activity/signuprecords/skip',
    {}
  );
}
